/**
 * Ant Design token overrides for the Email Insights module.
 */
import { theme as antdTheme } from 'antd';

export function getEmailInsightsTheme(isDark) {
  return {
    algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
    token: {
      colorPrimary: '#6366f1',
      colorSuccess: '#22c55e',
      colorWarning: '#f59e0b',
      colorError: '#ef4444',
      borderRadius: 10,
      fontFamily: 'inherit',
      colorBgBase: isDark ? '#141414' : '#ffffff',
      colorTextBase: isDark ? '#f8fafc' : '#0f172a',
      colorBorder: isDark ? '#303030' : '#e5e7eb',
    },
    components: {
      Card: { borderRadiusLG: 12 },
      Button: { borderRadius: 8 },
      Table: { borderRadius: 8 },
    },
  };
}
